export default __webpack_public_path__ + "static/media/svg-6.23fd8a5d.svg";